import httpClient from 'shared/lib/httpClient';
import { parseProcedureList } from '../schemas/MasterDataSchema';

export const getProcedureList = async (params, signal) => {
  const response = await httpClient.get('/procedures', { params, signal });
  return parseProcedureList(response?.data);
};
